export enum PaymentTypes {
  MANUAL_CREDIT = 'manual_credit',
  CASINO_REWARD = 'casino_reward',
}

export enum VipPaymentTypes {
  VIP = 'vip',
  ADMIN = 'admin',
}
